<template>


  <div>

    <!-- {{vendedor}} -->
    <!-- <hr></hr> -->
    <!-- {{vendedores }} -->



        <!-- {{usuarios}} -->

    
    <!-- {{vendedores}} -->



    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>



    <EditarVendedorDialog ref="editarVendedorDialog" @actualizado="despuesDeActualizar"></EditarVendedorDialog>


    <!-- <h3>{{vendedor}}</h3>  -->

    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Registro de Vendedores</v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab">

        <v-tab href="#one">
          <v-icon left>mdi-account</v-icon>
          Registro
        </v-tab>

        <v-tab href="#two">
          <v-icon left>mdi-dns</v-icon>
          Listado
        </v-tab>
      </v-tabs>
      <v-tabs-items :value="tab">
        <!-- <div :value="tab"> -->
        <v-tab-item value="one">
          <v-card flat>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>


                <!-- <v-text-field v-model="vendedor.nombre" label="Nombre" :counter="3" :rules="textRules"
                  required></v-text-field> -->


<v-container>
  <v-row>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.nombre"
        label="Nombre"
        outlined
        dense
        required
      />
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.apellido"
        label="Apellido"
        outlined
        dense
        required
      />
    </v-col>

    <v-col cols="12" md="6">
  <v-text-field
    v-model="vendedor.identificador"
    label="Identificador"
    outlined
    dense
    @blur="buscarUsuario"
  />
</v-col>



<v-col cols="12" md="6">
  <v-text-field
    v-model="vendedor.user.name"
    label="Nombre del Usuario"
    outlined
    dense
    disabled
  />
</v-col>

<v-col cols="12" md="6">
  <v-text-field
    v-model="vendedor.user.email"
    label="Email del Usuario"
    outlined
    dense
    disabled
  />
</v-col>





    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.numero_documento"
        label="Número de Documento"
        outlined
        dense
        type="number"
      />
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.fecha_nacimiento"
        label="Fecha de Nacimiento"
        type="date"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12">
      <v-text-field
        v-model="vendedor.direccion"
        label="Dirección"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.celular"
        label="Celular"
        outlined
        dense
      />
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="vendedor.correo_principal"
        label="Correo Principal"
        type="email"
        outlined
        dense
      />
    </v-col>

    <v-col cols="6">
      <v-text-field
        v-model="vendedor.correo_secundario"
        label="Correo Secundario"
        type="email"
        outlined
        dense
      />
    </v-col>


  </v-row>
</v-container>

             






               



                <v-btn :disabled="!valid" color="success" class="mr-4" @click="registrar">
                  Registrar
                </v-btn>

                <v-btn color="error" class="mr-4" @click="reset();">
                  Cancelar
                </v-btn>

              </v-form>
            </v-card-text>


            <v-card-text>

              <v-alert colored-border type="info" elevation="2">
                El presente registro es responsable de almacenar información sobre el Vendedor.<br>

                    {{vendedor}}

              </v-alert>

            </v-card-text>




          </v-card>
        </v-tab-item>

        <!--  fin item 1-->
        <v-tab-item value="two">
          <v-card flat>
            <v-card-text>

              <v-text-field v-model="buscador" placeholder="Ejemplo: Juan Perez" outlined>
                <template v-slot:label>
                  <v-icon style="vertical-align: middle">
                    mdi-magnify
                  </v-icon>
                  Busqueda por nombre de Vendedor
                </template>


              </v-text-field>




              <v-simple-table fixed-header>
                <template v-slot:default>


                  <thead class="thead-dark">
                    <tr>

                      <th scope="col">Id</th>
                      <th scope="col">Nombre</th>
                      <th scope="col">Apellido</th>
                       <th scope="col">Identificador</th>
                      <th scope="col">Número de documento</th>
                       <th scope="col">Fecha de Nacimiento</th>
                        <th scope="col">Dirección</th>
                         <th scope="col">Celular</th>
                          <th scope="col">Correo Principal</th>
                           <th scope="col">Correo Secundario</th>
                      <th scope="col">Editar</th>
                      <th scope="col">Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="vendedor in vendedoresBuscados" :key="vendedor.id">
                      <td>{{ vendedor.id }}</td>


                      <td>{{ vendedor.nombre }}</td>
  <td>{{ vendedor.apellido }}</td>
  <td>{{ vendedor.identificador }}</td>
  <td>{{ vendedor.numero_documento }}</td>
  <td>{{ vendedor.fecha_nacimiento }}</td>
  <td>{{ vendedor.direccion }}</td>
  <td>{{ vendedor.celular }}</td>
  <td>{{ vendedor.correo_principal }}</td>
  <td>{{ vendedor.correo_secundario }}</td>




                      <td>
                        <!-- <button @click="editarVendedor(vendedor)" class="btn"><v-icon left>mdi-pencil</v-icon></button> -->
                        <v-btn color="primary" @click="openEditarVendedorDialog(vendedor)">
                          <v-icon left>mdi-pencil</v-icon> Editar
                        </v-btn>
                      </td>
                      <td>
                        <button @click="eliminarVendedor(vendedor)" class="btn"><v-icon
                            left>mdi-delete-forever</v-icon></button>
                      </td>

                    </tr>
                  </tbody>


                </template>
              </v-simple-table>

            </v-card-text>
          </v-card>
        </v-tab-item>

        <!--  fin item 2-->


      </v-tabs-items>

      <!-- </div> -->
    </v-card>

  </div>
</template>


<script>




import vendedorService from "@/services/tienda/vendedorService.js";

import usuarioService from "@/services/usuarioService.js";


import axios from 'axios'
import EditarVendedorDialog from "@/components/tienda/vendedor/EditarVendedorDialog.vue";




export default {

  name: 'Vendedor',
  components: { EditarVendedorDialog },

  computed: {
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get() {
        return this.$route.query.tab
      }
    }
  },
  data: vm => ({

    

    mensaje: {
      snackbar: false,
      text: '',
      color: '',
      timeout: 5000,
    },

    vendedorSeleccionado: {},
    valid: true,
    tab: "",
    buscador: '',
    showPass: false,
     vendedores: [],
    

    vendedor: {
      id: '',
      nombre: '',
      apellido: '',
      identificador: '',
      numero_documento: '',
      fecha_nacimiento: '',
      direccion: '',
      celular: '',
      correo_principal: '',
      correo_secundario: '',
          user: {
            id:'',
            identificador:'',
            name: '',
             email: ''
            }
    },


    rules: {
      required: value => !!value || 'Campo Requerido',
      min: v => v.length >= 5 || 'Minimo 5 caracteres'
    },
    messages: undefined,



    textRules: [
      (v) => !!v || "Campo es requerido",
      (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
    ],


  }),
  created() {

  }
  , mounted() {

    this.tab = "two";


    this.listarVendedoresAdmin();



  },

  methods: {

    buscarUsuario() {

    if (!this.vendedor.identificador) {
      return
    }

    this.getUsuarioParaVendedor(this.vendedor.identificador)
  },

  getUsuarioParaVendedor(identificador) {

    usuarioService
      .getUsuarioParaVendedor(identificador)
      .then((resposta) => {

  if (resposta.data.status) {
    this.vendedor.user.id = resposta.data.user.id
    this.vendedor.user.name = resposta.data.user.name
    this.vendedor.user.email = resposta.data.user.email
    this.vendedor.correo_principal=resposta.data.user.email;
  } else {
    this.vendedor.user.name = 'No encontrado'
    this.vendedor.user.email = 'No encontrado'
  }

})
      .catch(() => {


        this.vendedor.user.name = 'Ocurrio un error'
        this.vendedor.user.email = 'Ocurrio un error'
      })
  }
    
    
    
    ,

    listarVendedoresAdmin() {
      vendedorService
        .listarVendedoresAdmin()
        .then((resposta) => {
          //    console.log(resposta.data);
          this.vendedores = resposta.data;
        })

    },

    despuesDeActualizar() {

      let mensajeText = 'Actualizado correctamente...';


      this.mensaje.text = mensajeText;

      this.mensaje.color = "success";
      this.mensaje.colorBtn = "green darken-1";

      this.mensaje.snackbar = "true";

      this.listarVendedoresAdmin();


    },

    openEditarVendedorDialog(vendedor) {
      this.vendedorSeleccionado = { ...vendedor }


      this.$refs.editarVendedorDialog.openDialog(this.vendedorSeleccionado)


    },







    listarVendedoresAdmin() {
      vendedorService
        .listarVendedoresAdmin()
        .then((resposta) => {
          //    console.log(resposta.data);
          this.vendedores = resposta.data;
        })

    },
    registrar() {
      if (this.$refs.form.validate()) {




        console.log(this.vendedor);

        vendedorService.save(this.vendedor, this.config).then(resposta => {
          this.limpiar();

          let mensajeText = 'Registro exitoso';
          this.mensaje.text = mensajeText;
          this.mensaje.color = "success";
          this.mensaje.colorBtn = "green darken-1";
          this.mensaje.snackbar = "true";

          this.listarVendedoresAdmin();
          this.selectedTab = "second";
        }).catch((errors) => {

          let mensajeError = 'Ha ocurrido un error:\n';

          // Recorremos el array de errores del backend
          if (errors.response && errors.response.data && errors.response.data.errors) {
            errors.response.data.errors.forEach((err, index) => {
              mensajeError += `${index + 1}. ${err}\n`;
            });
          } else {
            mensajeError += 'Error desconocido';
          }

          // Asignamos al snackbar
          this.mensaje.text = mensajeError;
          this.mensaje.snackbar = true; // debe ser boolean
          this.mensaje.color = "error"; // fondo rojo
          this.mensaje.colorBtn = "red darken-2"; // color de botón contraste


        })

      }
    },
    editarVendedor(vendedor) {


      this.vendedor.id = vendedor.id;
      this.vendedor.nombre = vendedor.nombre;

      this.tab = "one";

      console.log(vendedor);

    },
    eliminarVendedor(vendedor) {

      if (confirm('Desea remover al vendedor')) {

        vendedorService.delete(vendedor).then(resposta => {

          let mensajeText = 'Registro eliminado correctamente';
          this.mensaje.text = mensajeText;
          this.mensaje.color = "success";
          this.mensaje.colorBtn = "green darken-1";
          this.mensaje.snackbar = "true";



          this.listarVendedoresAdmin();
          this.errors = []
          this.limpiar();

        }).catch(e => {

          this.errors = e.response.data.errors

        })

      }





    },
    limpiar() {


     this.vendedor = {
  id: '',
  nombre: '',
  apellido: '',
  identificador: '',
  numero_documento: '',
  fecha_nacimiento: '',
  direccion: '',
  celular: '',
  correo_principal: '',
  correo_secundario: ''
  ,
          user: {
            id:'',
            identificador:'',
            name: '',
             email: ''
            }
}



    },

    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  },

  watch: {
    date(val) {



    },
  },
  computed: {




    vendedoresBuscados() {
      return this.vendedores.filter(vendedor => {
        return vendedor.nombre.toLowerCase().includes(this.buscador.toLowerCase());
      });

    }






  },
};
</script>
